import { Container, Row, Col } from 'react-bootstrap';

const RiskAssessment = () => {
  return (
    <Container fluid>
      <Row>
        <Col></Col>
        <Col></Col>
      </Row>
    </Container>
  );
};

export default RiskAssessment;
